<template>
    <b-modal v-model="modalAberto" size="lg" @hidden="cancelar" button-size="md" hide-footer
        :title="'Item Bem Permanente > Foto do Item Bem Permanente > '+(edicao?'Edição': 'Cadastro')" >
        <FotoIBPAdicionar :edicao="edicao" @fecharModal="cancelar" :modal="true"  :idFoto="idFoto" :id="id"></FotoIBPAdicionar>
    </b-modal>
</template>

<script>

import FotoIBPAdicionar from '@/modules/patrimonio/fotoibp/FotoIBPAdicionar.vue';

export default {
    name: "ModalModalFotoIBPAdicionar",
    components: {
        FotoIBPAdicionar,
    },
    props: {
        id: Number,
        edicao: Boolean,
        idFoto: Number

    },
    data() {
        return {
            modalAberto: true,
        }
    },
    methods: {
        cancelar() {
            this.$emit('fecharModal');
        },

    }
}

</script>